import React from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Typography } from 'components/alf-design';
import LinkedPolicies from './LinkedPolicies';

const MyPoliciesCard = ({ policies, isAdmin, onLinkPolicy }) => (
  <Card>
    <Typography
      type="h2"
      component="h2"
      id="my-policies-heading"
      className="mb-[24px] !text-legacy-textDarkSecondary"
    >
      My Policies
    </Typography>
    <ul className="list-none m-0 p-0">
      <LinkedPolicies policies={policies} />
    </ul>
    <Button
      type="primary"
      id="link-policy-button"
      data-dd-action-name="profile.policy.add_existing"
      className="mt-[24px]"
      fullWidth
      onClick={onLinkPolicy}
      disabled={isAdmin}
    >
      Add Existing Policy
    </Button>
  </Card>
);

MyPoliciesCard.propTypes = {
  policies: PropTypes.array.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  onLinkPolicy: PropTypes.func.isRequired,
};

export default MyPoliciesCard;
